import { useEffect } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../shared-components/Layout/DashboardLayout";
import { useSelector, useDispatch } from "react-redux";
import { userDetailsAction } from "../../features/auth/reducer/userReducer";
import PrimaryFormField from "../../shared-components/Form/PrimaryFormField";
import EmptyPage from "../../shared-components/Page/EmptyPage";
import purse from "../../assets/images/pursewallet.svg";
import { useNavigate } from "react-router-dom";

const BVNDetails = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userDetails);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "HerVest | Profile";
    dispatch(userDetailsAction());
  }, [dispatch]);

  return (
    <DashboardLayout title="Manage Account">
      <div>
        <div className="flex flex-row space-x-6 md:space-x-12 items-center pb-1 md:pb-3 pt-12 ">
          <Link to="/profile">
            <p className="flex text-[16px] font-[400px] leading-5 float-right text-[#666666]">
              Personal Indivation
            </p>
          </Link>
          <Link to="/nok">
            <p className="flex text-[16px] font-[400px] leading-5 float-right text-[#666666]">
              Next of Kin
            </p>
          </Link>
          <Link to="/bank">
            <p className="text-[14px] font-[400px] leading-5 float-right text-[#666666]">
              Banks
            </p>
          </Link>
          <Link to="/cards">
            <p className="text-[14px] font-[400px] leading-5 float-right text-[#666666]">
              Cards
            </p>
          </Link>
          <Link to="/update-password">
            <p className="text-[14px] font-[400px] leading-5 float-right text-[#666666]">
              Change Password
            </p>
          </Link>
        </div>
        <hr />

        {!user?.bvn && (
          <div className="w-full flex justify-center items-center">
            <div className="flex w-full md:w-[400px] mt-20 justify-center items-center">
              <EmptyPage
                title="Purse"
                header=""
                image={purse}
                headtext=""
                subtext="Kindly update your BVN to activate your purse and enjoy exclusive benefits on hervest"
                buttontext="UPDATE BVN"
                onClick={() => navigate("/purse")}
              ></EmptyPage>
            </div>
          </div>
        )}

        {user?.bvn && (
          <div className="pt-8 md:pt-16 pb-10">
            <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full">
              <div className="mb-2 md:mb-0">
                <label
                  className="block font-[500px] leading-7 MediumFonter"
                  htmlFor="inline-firstname"
                >
                  Your BVN Details
                </label>
              </div>
              <div className="w-full md:w-80">
                <PrimaryFormField value={user?.bvn} disabled />
              </div>
              <br />
            </div>

            <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full md:mt-6">
              <div className="mb-2 md:mb-0">
                <label
                  className="block font-[500px] leading-7 MediumFonter"
                  htmlFor="inline-lastname"
                >
                  BVN First Name
                </label>
              </div>
              <div className="w-full md:w-80">
                <PrimaryFormField value={user?.firstName} disabled />
              </div>
              <br />
            </div>

            <div className="md:grid md:grid-cols-3 md:gap-x-20 lg:gap-x-0 w-full md:mt-6">
              <div className="mb-2 md:mb-0">
                <label
                  className="block font-[500px] leading-7 MediumFonter"
                  htmlFor="last-name"
                >
                  BVN Last Name
                </label>
              </div>
              <div className="w-full md:w-80">
                <PrimaryFormField value={user?.lastName} disabled />
              </div>
              <br />
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default BVNDetails;
